import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import styled from 'styled-components';
import { Divider } from 'antd';
import { getFontSize } from '../../utils/commonFun';

const DividerPropsDefaults = {
    lineHeight: 1,
    lineColor: '#333333',
    variant: 'solid',
};

const StyledDDivider = styled(Divider)`
    &.ant-divider-horizontal.ant-divider-with-text::before,
    &.ant-divider-horizontal.ant-divider-with-text::after {
        border-block-start-width: ${({$borderTopWidth})=>($borderTopWidth+'px !important')};
        transform: unset !important;
    }
`;

export function CustomDivider({ fullWidthOnMobile, style, props }) {
    const isMobile = fullWidthOnMobile <= 480;
    const st = {
        padding: globalGetPadding(style?.padding, isMobile),
        backgroundColor: style?.backgroundColor ?? undefined,
    };
    const borderTopWidth = props?.lineHeight ?? DividerPropsDefaults.lineHeight;
    const borderTopColor = props?.lineColor ?? DividerPropsDefaults.lineColor;
    const lineText = props?.lineText ?? undefined;
    const variant = props?.variant ?? DividerPropsDefaults.variant;
    const textStyle = {
        fontSize: getFontSize(style?.fontSize, isMobile),
        color: style?.color ?? DividerPropsDefaults.lineColor,
        fontWeight: style?.fontWeight ?? 'bold'
    }

    return (
        <div style={st}>
            {
                lineText ? <StyledDDivider
                    variant={variant}
                    style={{
                        borderColor: borderTopColor,
                    }}
                    $borderTopWidth={borderTopWidth}
                >
                    <span style={textStyle}>{lineText}</span>
                </StyledDDivider> : <Divider
                    variant={variant}
                    style={{
                        borderWidth: borderTopWidth,
                        borderColor: borderTopColor,
                    }}
                />
            }
        </div>
    );
}
